/* Atlas runtime for the Pitch theme: the small window.Atlas API the ported v2 product
   template scripts expect (money, isMobile, cart.add, toast), wired to Pitch's cart.
   Adding to cart posts to /cart/add.js with the cart section ids, then fires Pitch's
   cart:update event so the cart drawer, cart count and cart page refresh like a normal add. opts.open opens the
   Atlas cart drawer when the page has one, otherwise Pitch's. */
(function () {
  const A = (window.Atlas = window.Atlas || {});
  if (A.__pitchRuntime) return;
  A.__pitchRuntime = true;

  /* ───────── Money (same formatting as ac-cat-v2 theme.js) ───────── */
  function formatWithDelimiters(n, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(n) || n == null) return '0';
    const fixed = (n / 100).toFixed(precision);
    const parts = fixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }
  A.formatMoney = function (cents, format) {
    format = format || A.moneyFormat || '${{amount}}';
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    let v;
    switch (kind) {
      case 'amount_no_decimals': v = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': v = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: v = formatWithDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  };
  A.money = function (cents) {
    const whole = Math.round(cents) % 100 === 0;
    return A.formatMoney(cents, (A.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, whole ? '{{amount_no_decimals}}' : '{{amount}}'));
  };

  /* Market money format: the section passes 1000.00 formatted by Shopify (e.g. "RM1,000.00 MYR"),
     which is turned into a format string; the trailing currency code is dropped unless asked for. */
  (function () {
    const sample = A.moneySample;
    if (sample) {
      const m = String(sample).match(/\d[\d.,'\s]*\d/);
      if (m) {
        const t = m[0];
        let kind = 'amount';
        if (/^1\.000,00$/.test(t)) kind = 'amount_with_comma_separator';
        else if (/^1\.000$/.test(t)) kind = 'amount_no_decimals_with_comma_separator';
        else if (/^1,?000$/.test(t)) kind = 'amount_no_decimals';
        else if (/^1'000\.00$/.test(t)) kind = 'amount_with_apostrophe_separator';
        A.moneyFormat = String(sample).replace(t, '{' + '{' + kind + '}' + '}');
      }
    }
    if (A.moneyFormat && A.hideCurrencyCode && A.currencyCode) {
      A.moneyFormat = A.moneyFormat.replace(new RegExp('(?:\\s|&nbsp;)*' + A.currencyCode), '').trim();
    }
  })();

  A.isMobile = () => window.innerWidth < 1040;
  A.toast = function () {};

  /* ───────── Sold out, as the cart sees it ─────────
     Storefront stock counts every location, but the cart only sells from the locations that ship to the shopper,
     so a size can look in stock and then be refused. A refused variant is remembered for this visit (per country)
     and announced with atlas:soldout {ids}, so every picker greys it out. Pickers listen for the event; on load it
     fires once with what this visit already learned. */
  const soldKey = 'atlas-soldout:' + ((window.Shopify && window.Shopify.country) || '');
  let sold = [];
  try { sold = JSON.parse(sessionStorage.getItem(soldKey) || '[]'); } catch (e) { sold = []; }
  function announceSold(ids) {
    if (!ids.length) return;
    document.dispatchEvent(new CustomEvent('atlas:soldout', { detail: { ids: ids.map(Number) } }));
    ids.forEach((id) => {
      /* quick add size buttons on cards and related products */
      document.querySelectorAll('button[data-variant-id="' + id + '"], button[data-add="' + id + '"]').forEach((el) => {
        el.classList.add('is-oos');
        el.setAttribute('aria-disabled', 'true');
        if (el.hasAttribute('data-add')) el.disabled = true;
      });
    });
  }
  A.soldOut = {
    has: (id) => sold.indexOf(String(id)) > -1,
    add(id) {
      id = String(id);
      if (sold.indexOf(id) < 0) sold.push(id);
      try { sessionStorage.setItem(soldKey, JSON.stringify(sold)); } catch (e) {}
      announceSold([id]);
    }
  };
  if (sold.length) {
    const fire = () => announceSold(sold.slice());
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fire);
    else setTimeout(fire, 0);
  }
  const soldRe = /sold out|not available|unavailable|out of stock/i;

  /* ───────── Cart, through Pitch ───────── */
  const routes = () => (window.Theme && window.Theme.routes) || {};
  function cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component, [data-cart-drawer]'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }
  A.cart = {
    get() {
      const url = (routes().cart_url || '/cart') + '.js';
      return fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    },
    /* items: [{id, quantity, properties?}]; opts.open opens the cart drawer */
    add(items, opts) {
      opts = opts || {};
      const sections = cartSectionIds();
      return fetch(routes().cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [].concat(items), sections: sections.join(',') })
      })
        .then((r) => r.text().then((text) => {
          let body = {};
          try { body = text ? JSON.parse(text) : {}; } catch (e) { body = {}; }
          if (!r.ok || body.status) {
            /* Shopify's 422s carry a readable description, e.g. "You can't add more ... to the cart." */
            const description = body.description || (typeof body.message === 'string' && body.message !== 'Cart Error' ? body.message : '');
            const list = [].concat(items);
            if (soldRe.test(description) && list.length === 1) {
              /* one variant refused as sold out: remember it so the pickers grey it out */
              A.soldOut.add(list[0].id);
              throw { status: body.status || r.status, message: body.message || '', soldOut: true, description: 'Sorry, that size just sold out. Please pick another one.' };
            }
            throw { status: body.status || r.status, message: body.message || '', description: description };
          }
          return body;
        }), () => {
          throw { status: 0, message: 'network', description: '' };
        })
        .then((added) => A.cart.get().then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'atlas-pdp',
              data: { source: 'atlas-pdp', itemCount: cart.item_count, sections: added.sections }
            }
          }));
          if (opts.open && document.querySelector('[data-cart-drawer]')) {
            document.dispatchEvent(new CustomEvent('atlas:cart:open'));
          } else if (opts.open) {
            const drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) drawer.open();
          }
          return cart;
        }));
    }
  };
})();
